export enum CurrencyCodes {
    Eur = '€',
    Usd = '$'
}
